export const PRODUCT_LANGUAGE = [
  {id: 'en', name: 'English'},
  {id: 'de', name: 'Deutsche'},
  {id: 'en_us', name: 'American English'},
  {id: 'es', name: 'Español'},
  {id: 'fr', name: 'Français'},
  {id: 'it', name: 'Italiano'},
  {id: 'ja', name: '日本語'},
  {id: 'ko', name: '한국어'},
  {id: 'ru', name: 'русский'},
  {id: 'zh_cn', name: '简体中文'},
  {id: 'zh', name: '繁體中文'},
];



// WEBPACK FOOTER //
// ./src/app/core/language/product-languages.js